import { SoftwareAddonTemplate } from "../../../lib/model/addonTemplate";
import p2atcLogo from "../../images/templates/pilot2atc.png";

export const pilot2AtcTemplate: SoftwareAddonTemplate = {
  type: "software",
  id: "pilot2atc",
  title: "Pilot2ATC",
  platforms: ["msfs", "xplane", "p3d", "fsx"],
  image: p2atcLogo,
  content: [
    {
      title: "Before simulator start",
      roles: ["beforeSimStart"],
      content: [{ item: "Navigation data", setting: "Updated" }],
    },
    {
      title: "Simulator Flight Setup",
      roles: ["beforeSimFlightStart", "beforeSimStart", "flightPlanning", "cockpitPreparation"],
      content: [
        {
          item: "Pilot2ATC",
          setting: "Running",
        },
        {
          item: "ATC Flight Plan",
          setting: "Imported & Validated",
        },
      ],
    },
    {
      title: "Cockpit Preparation",
      roles: ["cockpitPreparation", "beforeFlightStart", "beforePushback"],
      content: [
        {
          item: "Pilot2ATC",
          setting: "Connected",
        },
        { item: "ATC Flight Plan", setting: "Filed" },
      ],
    },
    {
      title: "Descent",
      roles: ["beforeDescent", "approach", "landing", "afterLanding"],
      content: [{ item: "Pilot2ATC Parking Gate", setting: "Selected" }],
    },
  ],
};
